import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import useSeo from "@/lib/useSeo";
import { waLink } from "@/lib/content";
import SizeGuideSection from "@/components/site/SizeGuide";
import { OrderView } from "./OrderSuccess";

const PAGES = {
  about: ["About Kurtaani", ["Kurtaani began with a simple belief: ethnic wear should feel as good as it looks. We design breathable cotton kurtis, graceful Anarkali suits and festive sets for the modern Indian woman.", "Every piece is quality-checked for fabric, stitching and colour before it leaves our studio."]],
  contact: ["Contact Us", ["Email: support@kurtaani.com", "WhatsApp: +91 99999 99999 (Mon–Sat, 10am–7pm)", "We usually reply within a few hours."]],
  shipping: ["Shipping Information", ["Free shipping on all orders across India.", "Orders are dispatched within 24–48 hours. Metro cities: 2–3 days. Rest of India: 4–6 days.", "Cash on Delivery is temporarily paused during the festive season – all orders are prepaid via UPI."]],
  returns: ["Returns and Exchange", ["Free size exchange within 7 days of delivery.", "Items must be unworn, unwashed and with original tags.", "Raise a request on WhatsApp with your order number and we'll schedule a doorstep pickup."]],
  faqs: ["FAQs", ["Is COD available? – COD is temporarily paused during the festive season. Please pay via any UPI app.", "How do I pay? – Scan the UPI QR at checkout with Google Pay, PhonePe, Paytm or BHIM, then enter your 12-digit UPI transaction ID (UTR).", "How do I pick my size? – Use our size guide or WhatsApp us for a personal recommendation.", "Do you offer prepaid discounts? – Yes, an extra 10% off on every UPI order.", "Can I combine coupons? – One coupon per order; the Buy 2 offer and prepaid discount stack automatically."]],
  privacy: ["Privacy Policy", ["We collect only the information needed to process your order and improve your shopping experience.", "We never sell your personal data. Payment details are processed by secure, PCI-compliant partners."]],
  terms: ["Terms and Conditions", ["By using kurtaani.com you agree to our terms of sale, pricing and exchange policies.", "Product colours may vary slightly due to screen settings and natural dye variations."]],
  refund: ["Refund Policy", ["For prepaid orders cancelled before dispatch, refunds are issued to the original payment method within 5–7 working days.", "For quality issues, we offer a replacement or full refund after inspection."]],
};

const TrackOrder = () => {
  const [num, setNum] = useState("");
  const [phone, setPhone] = useState("");
  const [o, setO] = useState(null);
  const go = async (e) => {
    e.preventDefault();
    try { setO((await api.get(`/orders/${num.trim()}`, { params: { phone } })).data); } catch (err) { setO(null); toast.error(errMsg(err)); }
  };
  return (
    <div className="kt-container max-w-2xl py-14">
      <h1 className="font-serif-display text-5xl font-semibold">Track Your Order</h1>
      <form onSubmit={go} className="mt-8 grid gap-3 sm:grid-cols-3">
        <input data-testid="track-order-number-input" required value={num} onChange={(e) => setNum(e.target.value)} placeholder="Order no. (KRT…)" className="rounded-full border border-[#E7E2DB] bg-white px-4 py-3 text-sm" />
        <input data-testid="track-order-phone-input" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Mobile number" className="rounded-full border border-[#E7E2DB] bg-white px-4 py-3 text-sm" />
        <button data-testid="track-order-submit-button" className="btn-primary">Track</button>
      </form>
      <div className="mt-8">{o && <OrderView o={o} />}</div>
    </div>
  );
};

export default function InfoPage() {
  const { page } = useParams();
  const info = PAGES[page];
  useSeo(info?.[0] || (page === "track-order" ? "Track Order" : "Size Guide"), null);
  if (page === "track-order") return <TrackOrder />;
  if (page === "size-guide" || !info) return <SizeGuideSection />;
  return (
    <div data-testid={`info-page-${page}`} className="kt-container max-w-3xl py-14 sm:py-20">
      <h1 className="font-serif-display text-5xl font-semibold">{info[0]}</h1>
      <div className="mt-8 space-y-4 text-[#44403C]">{info[1].map((t) => <p key={t}>{t}</p>)}</div>
      <a href={waLink("Hi Kurtaani, I need help.")} target="_blank" rel="noreferrer" className="btn-outline mt-10">Chat with us on WhatsApp</a>
    </div>
  );
}
